import { createI18n } from '@smartsash/i18n';

import en from '@/locales/en.json';
import fr from '@/locales/fr.json';

type Language = 'en' | 'fr';

/**
 * Restore the persisted language before the instance boots so a saved `fr` isn't
 * clobbered by the default `en`. Reads the same `language-storage` key that
 * `useLanguageStore` (zustand persist) writes.
 */
function readPersistedLanguage(): Language {
  try {
    const raw = localStorage.getItem('language-storage');
    if (!raw) return 'en';
    const lang = (JSON.parse(raw) as { state?: { currentLanguage?: unknown } }).state
      ?.currentLanguage;
    return lang === 'fr' ? 'fr' : 'en';
  } catch {
    return 'en';
  }
}

const i18n = createI18n({
  app: 'admin',
  appResources: { en, fr },
  initialLanguage: readPersistedLanguage(),
});

export default i18n;
